(async () => {
    const svgSpriteResponse = await fetch('/themes/custom/drupack/resources/components/year-review/assets/svg-sprite.svg', {
        credentials: 'include',
    });
    const svgSpriteBody = await svgSpriteResponse.text();

    const container = document.createElement('div');
    container.classList.add('yr-svg-sprite');
    container.style.display = 'none';
    container.innerHTML = svgSpriteBody;
    document.body.insertBefore(container, document.body.childNodes[0]);
})();
